import React from 'react';
import Link, { withPrefix } from 'gatsby-link';

import Menu from '../Menu';

const Header = ({ languages, phone, layoutContext }) => (
  <div className="header">
    <div className="header-top">
      <div className="header-content">
        {languages.length > 1 ? (
          <div className="langbar-container">
            {languages.map(lang => (
              <div key={lang.code}>
                <Link to={`/${lang.code}/`}>{lang.text}</Link>
              </div>
            ))}
          </div>
        ) : null}
        <div className="mobile-number">
          {layoutContext.content.headerPhoneLabel}
          <a href={`tel:${layoutContext.content.headerPhone}`}>
            {layoutContext.content.headerPhone}
          </a>
        </div>
      </div>
    </div>
    <div className="header-main">
      <div className="header-content">
        <Link to={`${layoutContext.pathPrefix}/`}>
          <img className="logo" src={withPrefix('/logo3.png')} alt="Logo" />
        </Link>
        <Menu layoutContext={layoutContext} />
        <div className="clear" />
      </div>
    </div>
  </div>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.jsx